var _style, _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVimbalLogoHEarth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1370.42 499.53",
    style: {
      enableBackground: "new 0 0 1370.42 499.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A231E;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000134217630027635490060000009765418628371378872_);}\n\t.st3{fill:#2C5868;}\n\t.st4{fill:url(#SVGID_00000082346350862413464670000013757570200164882598_);}\n\t.st5{fill:url(#SVGID_00000005248781033621996850000017106190957155103423_);}\n\t.st6{fill:#4F6445;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.17,208.09c-6.18,0-11.19,5.01-11.19,11.19v122.87c0,6.18,5.01,11.19,11.19,11.19 c6.18,0,11.19-5.01,11.19-11.19V219.27C595.36,213.09,590.35,208.09,584.17,208.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.68,208.09c-16.27-0.08-30.78,7.47-40.16,19.28c-9.38-11.81-23.89-19.36-40.16-19.28 c-28.11,0.14-50.68,23.29-50.68,51.4v82.83c0,6.09,4.94,11.03,11.03,11.03h0.28c6.1,0,11.05-4.96,11.03-11.06l-0.28-83.26 c0-15.92,12.95-28.88,28.88-28.88c15.84,0,28.74,12.82,28.87,28.63c0,0.08,0,0.17,0,0.25v83.16c0,6.17,5,11.17,11.17,11.17 c6.18,0,11.19-5.02,11.17-11.21l-0.27-80.31v-2.81c0-0.08,0-0.17,0-0.25c0.14-15.93,13.24-28.83,29.24-28.62 c15.86,0.2,28.51,13.38,28.51,29.24v82.93c0,6.09,4.94,11.03,11.03,11.03s11.03-4.94,11.03-11.03v-82.83 C812.36,231.38,789.79,208.22,761.68,208.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M921.23,207.78c-19.63,0-37.45,7.76-50.56,20.37v-20.07v-29.52c0-6.18-5.01-11.19-11.19-11.19 c-6.18,0-11.19,5.01-11.19,11.19v29.52v72.62l0,0c0,0,0,0.01,0,0.01c0,40.28,32.65,72.93,72.93,72.93 c40.4,0,72.93-32.53,72.93-72.93C994.16,240.43,961.51,207.78,921.23,207.78z M957.14,316.63c-9.59,9.59-22.35,14.88-35.91,14.88 c-13.57,0-26.32-5.28-35.91-14.88c-9.59-9.59-14.88-22.35-14.88-35.91c0,0,0-0.01,0-0.01h0.23v-4.82 c1.1-11.74,6.2-22.64,14.65-31.08c9.59-9.59,22.35-14.88,35.91-14.88c13.57,0,26.32,5.28,35.91,14.88 c9.59,9.59,14.88,22.35,14.88,35.91C972.02,294.28,966.74,307.03,957.14,316.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1080.57,207.78c-40.4,0-72.93,32.53-72.93,72.93c0,40.28,32.65,72.93,72.93,72.93 c19.63,0,37.45-7.76,50.56-20.37v8.87c0,6.18,5.01,11.19,11.19,11.19c6.18,0,11.19-5.01,11.19-11.19v-61.43 C1153.5,240.43,1120.85,207.78,1080.57,207.78z M1131.13,280.71v1.2c-0.3,13.06-5.53,25.29-14.8,34.56 c-9.55,9.55-22.25,14.81-35.76,14.81s-26.21-5.26-35.76-14.81c-9.55-9.55-14.81-22.25-14.81-35.76c0-13.51,5.26-26.21,14.81-35.76 c9.55-9.55,22.25-14.81,35.76-14.81s26.21,5.26,35.76,14.81c9.55,9.55,14.81,22.25,14.81,35.76H1131.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M537.86,208.11c-3.94,0-7.57,2.1-9.54,5.51l-62.62,108.26l-62.63-108.26c-1.97-3.41-5.61-5.51-9.54-5.51 c-8.49,0-13.8,9.2-9.54,16.55L454.75,347c2.43,4.21,6.69,6.32,10.94,6.32c4.25,0,8.5-2.1,10.94-6.31l70.77-122.36 C551.65,217.3,546.35,208.11,537.86,208.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1211.32,319.41V178.55c0-6.18-5.01-11.19-11.19-11.19c-6.18,0-11.19,5.01-11.19,11.19v140.86 c0,13.82,7.54,22.26,9.68,24.78c2.14,2.52,9.89,9.46,15.71,9.46c5.82,0,11.41-4.42,11.41-11.31c0-3.2-1.65-7.6-5.79-9.7 C1215.82,330.55,1211.32,326.39,1211.32,319.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.7493,
    y1: 339.4959,
    x2: 344.5677,
    y2: 339.4959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3805,
    style: {
      stopColor: "#4F6445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8822,
    style: {
      stopColor: "#8F5329"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.05,390.76c-4.88,0-9.46-1.9-12.91-5.35l-84.2-84.2c-2.92-2.92-2.92-7.66,0-10.58 c2.92-2.92,7.66-2.92,10.58,0l84.2,84.2c0.84,0.84,1.82,0.96,2.33,0.96s1.49-0.13,2.33-0.96l84.41-84.41 c2.92-2.92,7.66-2.92,10.58,0c2.92,2.92,2.92,7.66,0,10.58l-84.41,84.41C254.52,388.86,249.93,390.76,245.05,390.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140718767483717171760000005471444619792969875_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.7493,
    y1: -99.5833,
    x2: 344.5677,
    y2: -99.5833,
    gradientTransform: "matrix(1 0 0 -1 0 96.8973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2574,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5601,
    style: {
      stopColor: "#4F6445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F5329"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140718767483717171760000005471444619792969875_)"
    },
    d: "M245.05,145.21 c-4.88,0-9.46,1.9-12.91,5.35l-84.2,84.2c-2.92,2.92-2.92,7.66,0,10.58c2.92,2.92,7.66,2.92,10.58,0l84.2-84.2 c0.84-0.84,1.82-0.96,2.33-0.96s1.49,0.13,2.33,0.96l84.41,84.41c2.92,2.92,7.66,2.92,10.58,0c2.92-2.92,2.92-7.66,0-10.58 l-84.41-84.41C254.52,147.11,249.93,145.21,245.05,145.21z"
  })), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232.59,299.25c-3.16,0-5.85-2.41-6.14-5.62c-0.33-3.66-0.56-7.59-0.69-11.67 c-0.49-15.7,0.61-33.89,2.94-48.67c3.9-24.69,9.22-29.32,13.9-30.6c10.52-2.87,14.78,7.12,17.32,13.08 c1.34,3.14-0.12,6.76-3.26,8.1c-3.14,1.34-6.76-0.12-8.1-3.26c-0.49-1.16-1.62-3.79-2.55-5.29c-4.04,7.3-8.84,36.92-7.92,66.24 c0.12,3.84,0.34,7.52,0.65,10.94c0.31,3.39-2.2,6.4-5.59,6.7C232.97,299.24,232.78,299.25,232.59,299.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166673204559621165020000003172903514023608729_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.491,
    y1: 249.2906,
    x2: 223.89,
    y2: 316.2919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0249,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3575,
    style: {
      stopColor: "#4F6445"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166673204559621165020000003172903514023608729_)"
    },
    d: "M242.95,288.58c-0.04,0-0.08,0-0.13,0 l-0.11,0c-14.75-0.3-28.68-0.58-39.54-2.25c-5.54-0.85-22.4-3.46-22.79-16.09c-0.24-7.55,5.52-17.32,34.26-21.04 c3.38-0.44,6.48,1.95,6.91,5.33c0.44,3.38-1.95,6.48-5.33,6.91c-19.3,2.5-23.53,7.58-23.5,8.42c0.02,0.09,1.43,2.85,14.33,4.56 c9.85,1.3,22.51,1.56,35.91,1.83l0.11,0c3.41,0.07,6.12,2.89,6.05,6.3C249.05,285.9,246.3,288.58,242.95,288.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095307727698215942780000016618731446623985550_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.1989,
    y1: 252.1291,
    x2: 313.2513,
    y2: 307.5883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4143,
    style: {
      stopColor: "#4F6445"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095307727698215942780000016618731446623985550_)"
    },
    d: "M277.43,286.97 c-3.02,0-5.65-2.21-6.1-5.29c-0.49-3.37,1.85-6.51,5.22-7c0.58-0.08,1.38-0.17,2.21-0.26c0.79-0.08,1.77-0.19,2.2-0.27 c11.8-2.09,16.16-5.1,17.49-6.3c0.77-0.7,1.02-1.2,1.01-1.34c-0.04-1.35-3.32-3.25-10.56-4.46c-8.96-1.5-21.46-1.68-34.69-1.86 l-5.32-0.08c-3.41-0.05-6.13-2.86-6.08-6.27c0.05-3.37,2.81-6.08,6.17-6.08c0.03,0,0.07,0,0.1,0l5.3,0.08 c13.72,0.19,26.67,0.37,36.56,2.03c5.84,0.98,10.26,2.42,13.52,4.42c5.87,3.59,7.23,8.42,7.34,11.83 c0.09,2.8-0.72,6.96-5.08,10.89c-4.68,4.22-12.62,7.35-23.61,9.29c-0.84,0.15-1.91,0.26-3.03,0.38c-0.66,0.07-1.29,0.14-1.75,0.2 C278.02,286.95,277.72,286.97,277.43,286.97z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.72,333.9c-5.34,0-12.51-3.22-17.21-18.02c-1.03-3.25,0.77-6.72,4.02-7.75 c3.25-1.03,6.72,0.77,7.75,4.02c2.13,6.72,4.4,8.87,5.21,9.32c2.59-2.57,8.09-18.46,6.59-66.65c-0.12-3.84-0.34-7.53-0.65-10.95 c-0.31-3.4,2.2-6.4,5.59-6.7c3.41-0.31,6.4,2.2,6.7,5.59c0.33,3.66,0.56,7.59,0.69,11.67c0.42,13.53,0.52,33.03-1.43,49.1 c-1.55,12.86-4.99,30-16.85,30.37C248,333.9,247.86,333.9,247.72,333.9z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimbalLogoHEarth);
export default __webpack_public_path__ + "static/media/vimbal_logo_h_earth.3af3fd8c55e075a8538317b35375d42a.svg";
export { ForwardRef as ReactComponent };